import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { readCookie, removeCookie } from '@/tools/tools';
import { productTypeListPC, productTypeList, hotWordsList, hotWordsSelect, getSearchList, clearSingleSearchList, hotWordsSearchJson } from '@/services/http';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.isDelete = false;
    _this.value = '';
    _this.isLogin = false;
    _this.isShow = false;
    _this.ishistory = true;
    _this.showHistory = false;
    _this.isClassifyShow = false;
    // whiteStauts: Object = {}
    _this.productTypeId = 0;
    // 导航第一个分类id
    _this.firstProductId = '';
    // 分类列表
    _this.productTypeList = [];
    _this.hotWordsList = [];
    _this.searchList = []; // 历史记录
    // 分类列表子分类
    _this.productTypeChildren = [];
    _this.shoppingList = [];
    _this.classifyIndex = 0;
    _this.currentIndex = -1;
    _this.isMenuShow = false;
    _this.indexServiceStr = [];
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function () {
      var _created = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.$route.query.version || localStorage.getItem('isDlabel') === '1') {
                this.isShow = true;
                localStorage.setItem('isDlabel', '1');
              } else {
                localStorage.setItem('isDlabel', '0');
                this.isShow = false;
              }
              this.gethotWordsList();
              this.isLogin = !!readCookie('accessToken');
              this.value = this.$route.query.keyword ? String(this.$route.query.keyword) : '';
              // this.getProductTypeList()
              _context.next = 6;
              return this.queryFirstBuy();
            case 6:
              if (this.isLogin) {
                this.messageSimple();
              }
              this.isClassifyShow = this.isClassify;
              this.indexServiceStr = this.notifysState.serviceList.indexServiceStr.split(',');
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function created() {
        return _created.apply(this, arguments);
      }
      return created;
    }()
  }, {
    key: "mounted",
    value: function mounted() {}
  }, {
    key: "handClose",
    value: function handClose() {
      this.$router.push('/card');
    }
  }, {
    key: "hiddenFocus",
    value: function hiddenFocus() {
      this.isDelete = false;
    }
  }, {
    key: "handTips",
    value: function handTips() {
      this.$emit('handTips');
    }
  }, {
    key: "handClick",
    value: function handClick() {
      // 将搜索词作为数据传递出去
      this.$emit('search-triggered');
    }
  }, {
    key: "hiddenBlur",
    value: function hiddenBlur() {
      if (!this.isDelete) {
        this.showHistory = false;
      }
    }
  }, {
    key: "openShow",
    value: function openShow() {
      this.showHistory = true;
      this.getSearch();
    }
  }, {
    key: "closeShowHistory",
    value: function closeShowHistory() {
      if (!this.isDelete) {
        this.showHistory = false;
      }
    }
  }, {
    key: "handleCommand",
    value: function handleCommand(command) {
      if (command === 'login') {
        var anchor = readCookie('anchor');
        if (anchor) {
          if (this.compareVersion(anchor.version, '3.10.600') >= 0) {
            ;
            this.webTransport.getUserLoginData(JSON.stringify({}));
          } else if (this.compareVersion(anchor.version, '3.6.5') >= 0) {
            ;
            window.QCefClient.invokeMethod('getUserLoginData', JSON.stringify({}));
          } else {
            ;
            window.JsIntrS.getUserLoginData({});
          }
        }
        removeCookie('accessToken');
        this.$router.push('/login');
      } else {
        this.$router.push('/user');
      }
    }
    // 比较版本
  }, {
    key: "compareVersion",
    value: function compareVersion(v1, v2) {
      v1 = v1.split('.');
      v2 = v2.split('.');
      var len = Math.max(v1.length, v2.length);
      // 调整两个版本号位数相同
      while (v1.length < len) {
        v1.push('0');
      }
      while (v2.length < len) {
        v2.push('0');
      }
      // 循环判断每位数的大小
      for (var i = 0; i < len; i++) {
        var num1 = parseInt(v1[i]);
        var num2 = parseInt(v2[i]);
        if (num1 > num2) {
          return 1;
        }
        if (num1 < num2) {
          return -1;
        }
      }
      return 0;
    }
  }, {
    key: "goback",
    value: function goback() {
      this.$router.back();
    }
  }, {
    key: "refresh",
    value: function refresh() {
      window.location.reload();
    }
  }, {
    key: "goOrderList",
    value: function goOrderList() {
      window.location.href = '/order-list';
    }
  }, {
    key: "deleteSearch",
    value: function () {
      var _deleteSearch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(id) {
        var _this2 = this;
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.isDelete = true;
              setTimeout(function () {
                ;
                _this2.$refs.hiddenInput.focus();
              }, 301);
              _context2.next = 4;
              return clearSingleSearchList({
                companyId: 1,
                searchId: id
              });
            case 4:
              res = _context2.sent;
              if (res.data.code === 100) {
                this.getSearch();
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function deleteSearch(_x) {
        return _deleteSearch.apply(this, arguments);
      }
      return deleteSearch;
    }()
  }, {
    key: "goMessage",
    value: function goMessage() {
      this.$router.push('/notifys');
    }
  }, {
    key: "search",
    value: function search() {
      hotWordsSearchJson({
        hotWord: this.value,
        channel: 0,
        companyId: 1
      });
      window.location.href = "/classify?keyword=".concat(this.value);
    }
  }, {
    key: "hotwordsSearch",
    value: function () {
      var _hotwordsSearch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(item) {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return hotWordsSelect({
                id: item.id
              });
            case 2:
              res = _context3.sent;
              if (res.data.code === 100) {
                window.location.href = "/classify?keyword=".concat(item.keyword);
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function hotwordsSearch(_x2) {
        return _hotwordsSearch.apply(this, arguments);
      }
      return hotwordsSearch;
    }() // 最近搜索查询
  }, {
    key: "getSearch",
    value: function () {
      var _getSearch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.ishistory = !!readCookie('accessToken');
              if (!this.ishistory) {
                _context4.next = 6;
                break;
              }
              _context4.next = 4;
              return getSearchList({
                companyId: 1
              });
            case 4:
              res = _context4.sent;
              this.searchList = res.data.data;
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getSearch() {
        return _getSearch.apply(this, arguments);
      }
      return getSearch;
    }()
  }, {
    key: "selectSearch",
    value: function selectSearch(item) {
      this.value = item.keyword;
      window.location.href = "/classify?keyword=".concat(this.value);
    }
    // 热门搜索
  }, {
    key: "gethotWordsList",
    value: function () {
      var _gethotWordsList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return hotWordsList({
                channel: 0,
                companyId: 1
              });
            case 2:
              res = _context5.sent;
              this.hotWordsList = res.data.data;
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function gethotWordsList() {
        return _gethotWordsList.apply(this, arguments);
      }
      return gethotWordsList;
    }()
  }, {
    key: "dropdownClassify",
    value: function dropdownClassify() {
      this.dropdownClick(Number(this.firstProductId), 0);
      this.currentIndex = 0;
      this.isClassifyShow = true;
      this.isMenuShow = true;
    }
  }, {
    key: "getProductTypeList",
    value: function () {
      var _getProductTypeList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var res;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return productTypeListPC({
                companyId: 1
              });
            case 2:
              res = _context6.sent;
              this.productTypeList = res.data.data.slice(0, 5);
              this.firstProductId = res.data.data[0] ? res.data.data[0].id : '';
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getProductTypeList() {
        return _getProductTypeList.apply(this, arguments);
      }
      return getProductTypeList;
    }()
  }, {
    key: "dropdownClick",
    value: function () {
      var _dropdownClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(productTypeId, index) {
        var res;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              this.currentIndex = index;
              this.productTypeId = productTypeId;
              _context7.next = 4;
              return productTypeList({
                productTypeId: productTypeId,
                companyId: 1
              });
            case 4:
              res = _context7.sent;
              if (res.data.code === 100) {
                this.productTypeChildren = res.data.data.children;
                this.classifyIndex = this.productTypeChildren.length;
                this.isMenuShow = true;
              }
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function dropdownClick(_x3, _x4) {
        return _dropdownClick.apply(this, arguments);
      }
      return dropdownClick;
    }()
  }, {
    key: "goDetails",
    value: function goDetails(productTypeId, name) {
      window.location.href = "/classify?productTypeId=".concat(productTypeId, "&name=").concat(name);
    }
    // 浏览更多
  }, {
    key: "watchMore",
    value: function watchMore() {
      this.$router.push("/classify?parentTypeId=".concat(this.productTypeId));
    }
  }, {
    key: "mouseLeave",
    value: function mouseLeave() {
      if (this.$route.name !== 'home') {
        this.isClassifyShow = false;
      }
      this.isMenuShow = false;
      this.currentIndex = -1;
    }
  }]);
}(Vue);
__decorate([Prop({
  default: true
})], default_1.prototype, "isClassifyBtn", void 0);
__decorate([Prop({
  default: false
})], default_1.prototype, "isClassify", void 0);
__decorate([Prop({
  default: false
})], default_1.prototype, "isFixed", void 0);
__decorate([State('equipment')], default_1.prototype, "printerModelInfor", void 0);
__decorate([State('card')], default_1.prototype, "cardstate", void 0);
__decorate([State('white')], default_1.prototype, "whiteState", void 0);
__decorate([State('user')], default_1.prototype, "userinfor", void 0);
__decorate([State('notifys')], default_1.prototype, "notifysState", void 0);
__decorate([Action('notifys/messageSimple')], default_1.prototype, "messageSimple", void 0);
__decorate([Action('notifys/queryFirstBuy')], default_1.prototype, "queryFirstBuy", void 0);
default_1 = __decorate([Component({
  name: 'Header'
})], default_1);
export default default_1;